import Apdex from './apdex';
import { ApdexEventType } from './apdexEventsName';

interface RenderedOptions {
    projectId: string;
}

interface Metrics {
    begin: number;
    sendRequest: number;
    responseReceived: number;
    rendered: number;
}

type ApdexEventNameType = {
    [key: string]: Metrics;
};

const ApdexTracker = {
    begin: (eventName: string) =>
        document.dispatchEvent(
            new CustomEvent(ApdexEventType.BEGIN, { detail: { timestamp: performance.now(), eventName } }),
        ),
    rendered: (eventName: string, options?: RenderedOptions) =>
        document.dispatchEvent(
            new CustomEvent(ApdexEventType.RENDERED, {
                detail: { timestamp: performance.now(), eventName, projectId: options?.projectId },
            }),
        ),
    sendRequest: (eventName: string) =>
        document.dispatchEvent(
            new CustomEvent(ApdexEventType.SEND_REQUEST, { detail: { timestamp: performance.now(), eventName } }),
        ),
    responseReceived: (eventName: string) =>
        document.dispatchEvent(
            new CustomEvent(ApdexEventType.RESPONSE_RECEIVED, {
                detail: { timestamp: performance.now(), eventName },
            }),
        ),
};

const initApdexEventListener = () => {
    const metrics: ApdexEventNameType = {};

    document.addEventListener(ApdexEventType.BEGIN, (({ detail }: CustomEvent) => {
        metrics[detail.eventName] = { begin: detail.timestamp, sendRequest: 0, responseReceived: 0, rendered: 0 };
    }) as EventListener);
    document.addEventListener(ApdexEventType.SEND_REQUEST, (({ detail }: CustomEvent) => {
        metrics[detail.eventName] = { ...metrics[detail.eventName], sendRequest: detail.timestamp };
    }) as EventListener);
    document.addEventListener(ApdexEventType.RESPONSE_RECEIVED, (({ detail }: CustomEvent) => {
        metrics[detail.eventName] = { ...metrics[detail.eventName], responseReceived: detail.timestamp };
    }) as EventListener);
    document.addEventListener(ApdexEventType.RENDERED, (({ detail }: CustomEvent) => {
        metrics[detail.eventName] = { ...metrics[detail.eventName], rendered: detail.timestamp };
        Apdex.emit(detail.eventName, {
            projectId: detail.projectId,
            renderTime: metrics[detail.eventName].rendered - metrics[detail.eventName].begin,
            requestTime: metrics[detail.eventName].responseReceived - metrics[detail.eventName].sendRequest,
        });
    }) as EventListener);
};

export { ApdexTracker, initApdexEventListener };
